import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getProductos,
  deleteProducto,
  getProductoById,
} from "../helpers/rutaProductos";
import ModalProducto from "./ModalProducto";
import "../css/tableclientes.css";

const TableProductos = () => {
  const [productos, setProductos] = useState({
    data: {},
    loading: true,
  });

  const [producto, setProducto] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaProductos();
  }, []);

  const consultaProductos = () => {
    getProductos().then((datos) => {
      console.log("📦 Productos:", datos);
      setProductos({
        data: datos,
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaProductos();
  };

  const handleShow = () => setShow(true);

  const modificaProducto = (id) => {
    getProductoById(id).then((resp) => {
      if (resp.ok) {
        setProducto(resp.producto); // ✅ ahora sí solo el objeto producto
        handleShow();
      } else {
        console.error("❌ Error al obtener producto:", resp.error);
      }
    });
  };

  const eliminarProducto = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar el producto?");
    if (confirmar) {
      deleteProducto(id).then(() => {
        consultaProductos();
      });
    }
  };

  return (
    <div className="table-container">
      {!productos.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th>Acciones</th>
                  <th>Nro</th>
                  <th className="cli">Producto</th>
                </tr>
              </thead>
              <tbody>
                {productos.data.productos.map((producto) =>
                  producto.activo ? (
                    <tr key={producto._id}>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => modificaProducto(producto._id)}
                        >
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>
                        <button
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarProducto(producto._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>
                      <td>{producto.codpro}</td>
                      <td>{producto.producto}</td>
                      {/* <td>{producto.localidad?.localidad || "-"}</td> */}
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>
          <ModalProducto
            show={show}
            handleClose={handleClose}
            producto={producto}
          />
        </>
      )}
    </div>
  );
};

export default TableProductos;
